import { createSlice } from "@reduxjs/toolkit";
import { login, getUserByType, getOneUser  } from "./thunk"; // Import the async thunks

const initialState = {
  loginResponse:null,
  usersByType:[],
  oneUser:null,
  usersLoading:false,
  usersError:null,
  loading:false,
  error:null
};

const usersSlice = createSlice({
  name: "usersSlice",
  initialState,
  reducers: {
    clearResponses: (state) => {
      state.loginResponse = null;
      state.registerResponse = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.loginResponse = action.payload
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(getUserByType.pending, (state) => {
        state.usersLoading = true;
      })
      .addCase(getUserByType.fulfilled, (state, action) => {
        state.usersLoading = false;
        state.usersByType = action.payload
      })
      .addCase(getUserByType.rejected, (state, action) => {
        state.usersLoading = false;
        state.usersError = action.error.message;
      });
    builder
      .addCase(getOneUser.pending, (state) => {
        state.usersLoading = true;
      })
      .addCase(getOneUser.fulfilled, (state, action) => {
        state.usersLoading = false;
        state.oneUser = action.payload
      })
      .addCase(getOneUser.rejected, (state, action) => {
        state.usersLoading = false;
        state.usersError = action.error.message;
      });



  },
  

});

export default usersSlice.reducer;
